import locale from '../locale/default';
export default locale;



// WEBPACK FOOTER //
// ./components/locale-provider/default.tsx